import { FormattedMessage } from 'react-intl';

const serviceOrderCategories = [
    'cleaning',
    'parking',
    'fueling-or-charging',
    'fueling',
    'charging',
    'assembly',
    'other',
    'tour-start',
    'tour-end',
] as const;

export const isKnownServiceOrderCategory = (category?: string): boolean =>
    serviceOrderCategories.some(knownCategory => knownCategory === category);

export const getServiceOrderIcon = (category?: string): 'icon-battery-charging' | 'icon-wrench' =>
    category === 'charging' ? 'icon-battery-charging' : 'icon-wrench';

export const ServiceTypeName = ({ category, fallback }: { category?: string; fallback: string }) =>
    isKnownServiceOrderCategory(category) ? (
        <FormattedMessage id={`intl-msg:ordercom-cloud-frontend.service.type.${category}`} />
    ) : (
        fallback
    );
